import React from "react";
import { Icon } from "@cadmakers-ui/icons";
import iconStyles from "../../../../Common/Styles/Icons.module.scss";
import { CommentLike } from "../../../Models/CommentLike";

import "../../../Styles/CommentVoteButton.scss";
import "../../../Styles/CommentBox.scss";

type Props = {
  commentId: number;
  voteCount: number;
  existingVote: string;
  onLike: (commentId: number) => void;
};

type State = {
  voteCount: number;
  existingVote: string;
};

export class CommentLikeButton extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      voteCount: this.props.voteCount,
      existingVote: this.props.existingVote
    };
  }

  onLike = () => {
    switch (this.state.existingVote) {
      case CommentLike.Like:
        this.setState(prevState => ({
          existingVote: CommentLike.None,
          voteCount: prevState.voteCount - 1
        }));
        break;
      case CommentLike.None:
        this.setState(prevState => ({
          existingVote: CommentLike.Like,
          voteCount: prevState.voteCount + 1
        }));
        break;
      default:
        throw new Error(`Invalid vote state "${this.state.existingVote}"`);
    }

    this.props.onLike(this.props.commentId);
  };

  render() {
    return (
      <a onClick={this.onLike} className="disable-double-click-select">
        {this.state.existingVote === CommentLike.Like ? (
          <Icon
            appName="GeneralLayout"
            assetName="GENERAL_L_Plus"
            className={iconStyles.tinyIcon}
          />
        ) : (
          <Icon appName="cmBuilder" assetName="GENERAL_L_Plus" className={iconStyles.tinyIcon} />
        )}
        <span className="vote-count">{this.state.voteCount}</span>
      </a>
    );
  }
}
